<template>
  <div class="report-contain" v-if="showType && count_down > 0" ddt-area="上报组件" ddt-expose="on">
    <div class="report-box" >{{count_down}}s后完成任务</div>
  </div>
</template>

<script>
export default {
  name: "spe-report",
  data(){
    return {
      count_down: '',
      showType:false
    }
  },
  created() {
    if(this.$route.query.fr && this.$route.query.task_type == 1  ){
      if( this.$route.query.count_down > 0){
        this.showType = true
        this.countdown()
      }else{
        this.getReportData()
      }
    }
  },
  mounted() {
  },
  methods:{
    countdown(){
      let count_down = this.$route.query.count_down || ''
      let timer = setInterval(()=>{
        if(count_down <= 0) {
          clearInterval(timer)
          this.showType = false
          this.getReportData()
          return
        }else{
          this.count_down = count_down--
        }
      },1000)
    },
    async getReportData(){
      const {global_province_id,person_on,activity_id,task_id,task_type,count_down,client_version} = this.$route.query
      const params = {
        a: 'task-complete',
        c: 'reading-plan',
        global_province_id:global_province_id,
        person_on:person_on,
        task_id:task_id,
        activity_id:activity_id,
        task_type:task_type,
        client_version:client_version
      }
      let { errorCode, data } =  await this.$axios.get("/mapi7/reading-plan/index.php", { params })
      try {
        if(errorCode == 0 && this.$route.query.count_down > 0){
          this.$toast(data.award_desc || '恭喜您完成任务')
        }
      }catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .report-contain{
    position: fixed;
    bottom: 1.4rem;
    left: 0;
    z-index: 999;
    .report-box{
      display: block;
      width: 2.4rem;
      height: .6rem;
      background-color: rgba(0,0,0,.6);
      text-align: center;
      line-height: .6rem;
      color: #fff;
      border-bottom-right-radius: .3rem;
      border-top-right-radius: .3rem;
      font-size: .24rem;
    }
  }

</style>
